// Link de pago por correo (founder 22-oct-2026) — estado para el barbero + «Reenviar correo». Cobrar y detalle de la cita.
import { useState } from 'react';
import { Mail, RefreshCw, Loader2, CheckCircle2, Ban } from 'lucide-react';
import { toast } from 'sonner';
import { bookingApi } from '@/lib/bookingApi';
import { friendlyError } from '@/lib/apiError';
import { tr } from '@/contexts/LanguageContext';
import { fmtMoney } from '@/utils/money';

const ago = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return tr("ahora mismo");
  if (m < 60) return tr("hace {0} min", m);
  const h = Math.round(m / 60);
  return h < 48 ? tr("hace {0} h", h) : tr("hace {0} días", Math.round(h / 24));
};

export const PayLinkStatus = ({ booking, onChanged }) => {
  const pl = booking?.pay_link;
  const bid = booking?.booking_id || booking?.id;
  const [busy, setBusy] = useState(false);
  if (!pl) return null;
  const resend = async () => {
    setBusy(true);
    try {
      const r = await bookingApi.payLinkResend(bid, {});
      toast.success(tr("Correo reenviado a {0}. El link anterior ya no funciona.", r.pay_link.email_masked));
      onChanged?.({ ...booking, pay_link: { ...pl, ...r.pay_link } });
    } catch (e) { toast.error(friendlyError(e, tr("No se pudo reenviar"))); } finally { setBusy(false); }
  };
  const Icon = pl.status === 'paid' ? CheckCircle2 : pl.status === 'cancelled' ? Ban : Mail;
  const color = pl.status === 'paid' ? 'text-emerald-400' : pl.status === 'cancelled' ? 'text-muted-foreground' : 'text-primary';
  return (
    <div className="bg-background border border-border rounded-xl p-2.5 flex items-start gap-2 flex-wrap" data-testid={`pay-link-status-${bid}`}>
      <Icon className={`w-4 h-4 shrink-0 ${color}`} />
      <p className="flex-1 min-w-0 text-[11px] text-foreground leading-snug" data-testid={`pay-link-text-${bid}`}>
        {tr("Enviado a {0} {1} · {2}", pl.email_masked, ago(pl.sent_at),
          pl.status === 'paid' ? tr("pagado desde el correo") : pl.status === 'cancelled' ? tr("anulado (cobrado por {0})", pl.closed_via === 'cash' ? tr("efectivo") : 'QR') : tr("pendiente de pago · {0}", fmtMoney(pl.amount)))}
      </p>
      {pl.status === 'pending' && (
        <button type="button" onClick={resend} disabled={busy} className="shrink-0 inline-flex items-center gap-1 rounded-full border border-border px-2.5 py-1 text-[11px] font-semibold text-foreground hover:border-primary/50 disabled:opacity-60"
          data-testid={`pay-link-resend-${bid}`}>
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <RefreshCw className="w-3 h-3" />} {tr("Reenviar correo")}
        </button>
      )}
    </div>
  );
};
